import { 
  SET_ACTIVE_PO,
  SET_NOT_ACTIVE_PO,
  GET_DOC_CONTROL,
  SET_PO_CONTRACT,
  GET_PO_CONTRACT,
  }  from "../actions/actionTypes";
  import { v4 as uuidv4 } from 'uuid';

  const initialState = {
        sessionNo:new Date().getTime()+""+uuidv4(),
        LockAction:null,
        docData:[],
        po_contract_no:"",
   }

  function DocControlRedux(state = initialState, action) {
    switch (action.type) {
      case SET_ACTIVE_PO:
        return{
            ...state,
            LockAction:true
        }
      case SET_NOT_ACTIVE_PO:{
        return{
          ...state,
          LockAction:false
        }
      }
      case GET_DOC_CONTROL:
        return {
          ...state,
          docData: action.payload,
        }
        case SET_PO_CONTRACT:
          return {
            ...state,
            po_contract_no: action.payload,
          }   
          case GET_PO_CONTRACT:
            return {
              ...state,
              po_contract_no: action.payload,
            }       
      default:
        return state
    }
  }
  
  export default DocControlRedux;